// extracted by mini-css-extract-plugin
export var colorSquare = "_s1-0";
export var danger = "_s1-5";
export var lightPink = "_s1-8";
export var neutralBlue = "_s1-7";
export var neutralYellow = "_s1-6";
export var normal = "_s1-1";
export var primary = "_s1-2";
export var primaryLight = "_s1-3";
export var solidBlack = "_s1-g";
export var solidGreen = "_s1-b";
export var solidLightBlue = "_s1-d";
export var solidNavy = "_s1-c";
export var solidOrange = "_s1-f";
export var solidPink = "_s1-e";
export var solidRed = "_s1-9";
export var solidYellow = "_s1-a";
export var success = "_s1-4";